import dynamic from 'next/dynamic';
export const ImageTextSecondary = dynamic(() => import('./ImageTextSecondary'));
export { default } from './ImageTextSecondary';
